import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutMe } from './components/AboutMe';
import { WhoIHelp } from './components/WhoIHelp';
import { Approach } from './components/Approach';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { BrandAssets } from './components/BrandAssets';
export function App() {
  const [hash, setHash] = useState(typeof window !== 'undefined' ? window.location.hash : '');
  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (hash === '#brand-assets') {
    return <BrandAssets data-id="element-0" data-mp="23ti8y6semyl9" />;
  }
  return <div className="min-h-screen bg-offwhite-50 font-sans selection:bg-amber-500/30 selection:text-charcoal-950" data-id="element-1" data-mp="3ikhaeg9qb525">
      <Navbar data-id="element-2" data-mp="3mkhlbqxmcy4g" />
      <main data-id="element-3" data-mp="3mk83iqmq9x9u">
        <Hero data-id="element-4" data-mp="3mjq2lgp4euvl" />
        <AboutMe data-id="element-5" data-mp="3mj6ibtbzzuee" />
        <WhoIHelp data-id="element-6" data-mp="3rcj6618urx63" />
        <Approach data-id="element-7" data-mp="3rbzmog3k10py" />
        <Services data-id="element-8" data-mp="3rdkisa5iorpx" />
        <Testimonials data-id="element-9" data-mp="3rd1a7k1rbfok" />
        <Contact data-id="element-10" data-mp="3relwynhtxubv" />
        <CTASection data-id="element-11" data-mp="5opiv1o0k3w" />
      </main>
      <Footer data-id="element-12" data-mp="4n5i12o8na1" />
    </div>;
}